module.exports = __webpack_public_path__ + "static/media/Segoe UI Italic.347c3ac0.woff";